// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class LoadingService {

//   constructor() { }

//   loading$ = new BehaviorSubject<boolean>(false);

//   show() { this.loading$.next(true); }
//   hide() { this.loading$.next(false); }
// }


import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private counter = 0;

  constructor() {}

  private get spinner(): HTMLElement | null {
    return document.getElementById('nb-global-spinner');
  }

  show() {
    this.counter++;

    // Only show when counter becomes 1
    if (this.counter === 1 && this.spinner) {
      this.spinner.style.display = 'block';
    }
  }

  hide() {
    if (this.counter > 0) this.counter--;

    // Hide only when counter returns to zero
    if (this.counter === 0 && this.spinner) {
      this.spinner.style.display = 'none';
    }
  }

  forceHide() {
    this.counter = 0;
    if (this.spinner) this.spinner.style.display = 'none';
  }
}
